export interface ApprovalDataChangeSet {
    title: string;
    description?: string;
    changes: ApprovalDataChange[];
}

export interface ApprovalDataChange {
    entity: string;
    action: ApprovalDataChangeAction;
    fields: ApprovalDataChangeField[];
}

export enum ApprovalDataChangeAction {
    Inserted = "Inserted",
    Deleted = "Deleted",
    Updated = "Updated",
}

export interface ApprovalDataChangeField {
    name: string;
    originalValue?: string;
    newValue?: string;
}
